var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.009 6.715a1.512 1.512 0 103.015-.228 1.512 1.512 0 00-3.015.228zM10.006 12.372a1.511 1.511 0 103.022 0 1.511 1.511 0 00-3.022 0zM10.008 18.091a1.513 1.513 0 002.118 1.538 1.512 1.512 0 10-2.118-1.538z",
    fill: "#C4C4C4"
  })));
}
export default SvgOptions;